// src/PuaContext.js
import React, { createContext, useState, useEffect } from "react";

export const PuaContext = createContext();


export const PuaProvider = ({ children }) => {
  const sets = [
    [
      { src: "/images/pua_rosa1.webp", text: "Inicio", path: "/" },
      { src: "/images/pua_marron2.webp", text: "Obras", path: "/obras" },
      { src: "/images/pua_verde3.webp", text: "Bio", path: "/bio" },
      { src: "/images/pua_verde4.webp", text: "CV", path: "/cv" },
      { src: "/images/pua_verde5.webp", text: "Contacto", path: "/contacto" },
    ],
    [
      { src: "/images/pua_azul1.webp", text: "Inicio", path: "/" },
      { src: "/images/pua_azul2.webp", text: "Obras", path: "/obras" },
      { src: "/images/pua_azul3.webp", text: "Bio", path: "/bio" },
      { src: "/images/pua_azul4.webp", text: "CV", path: "/cv" },
      { src: "/images/pua_azul5.webp", text: "Contacto", path: "/contacto" },
    ],
    
  ];

  const [currentSet, setCurrentSet] = useState([]);

  useEffect(() => {
    const randomSet = Math.floor(Math.random() * sets.length);
    setCurrentSet(sets[randomSet]);
  }, []); 

  return (
    <PuaContext.Provider value={currentSet}>
      {children}
    </PuaContext.Provider>
  );
};